import * as http from 'utils/http';
import { localStorage } from 'utils/storage';
import history from 'modules/history';
import { disconnectWs } from './websockets';
import config from 'config';
import { captureMessage } from 'modules/sentry';

const loginRequest = () => ({
  type: 'LOGIN_REQUEST',
});

const loginDone = (user) => ({
  type: 'LOGIN_DONE',
  user,
});

const loginCancel = (error) => ({
  type: 'LOGIN_CANCEL',
  error,
});

export const logoutRequest = () => ({
  type: 'LOGOUT_REQUEST',
});

export const logoutDone = () => ({
  type: 'LOGOUT_DONE',
});

// There is no LOGOUT_CANCEL. Logout always succeeds, even if it doesn't

export const refreshTokenRequest = () => ({
  type: 'REFRESH_TOKEN_REQUEST',
});

export const refreshTokenDone = (user) => ({
  type: 'REFRESH_TOKEN_DONE',
  user,
});

export const refreshTokenCancel = (error) => ({
  type: 'REFRESH_TOKEN_CANCEL',
  error,
});

const doLogin = async ({ token, user, res }) => {
  try {
    let response = res;
    if (!response) {
      const authConfig = config.getAuthConfig(localStorage.getItem('useSAML'));
      response = await http.rawPost(authConfig.LOGIN.url, {
        ...authConfig.LOGIN.params,
        [authConfig.LOGIN.token_key]: token,
      });
    }

    const userInfo = {
      ...user,
      ...response,
      ...{ expires: Date.now() + response.expires_in * 1000 },
    };

    return userInfo;
  } catch (err) {
    const error = (await http.getError(err)) || {};
    await captureMessage(`There was problems with login`, { user, level: 'error', extra: error });
    throw err;
  }
};

export const login = (
  token,
  user,
  res,
  redirect = () => {
    /*noop*/
  }
) => {
  return async (dispatch) => {
    try {
      dispatch(loginRequest());
      const userInfo = await doLogin({ token, user, res });
      dispatch(loginDone(userInfo));
      localStorage.setItem('mercuryUser', JSON.stringify(userInfo));
      redirect();
    } catch (err) {
      dispatch(loginCancel(err));
    }
  };
};

export const postLogin = (userInfo, redirect = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch(loginDone(userInfo));
      localStorage.setItem('mercuryUser', JSON.stringify(userInfo));
      localStorage.setItem('useSAML', true);
      redirect();
    } catch (err) {
      dispatch(loginCancel(err));
    }
  };
};

export const loginJWTAuth = (token) => {
  localStorage.setItem('sso_token', token);
  localStorage.setItem('useSAML', true);
  const tokenInfo = JSON.parse(atob(token.split('.')[1]));
  const refreshToken = tokenInfo.exp * 1000;
  const userInfo = {
    ...tokenInfo.user,
    access_token: token,
    refresh_token: token,
    ...{ expires: refreshToken },
  };

  return userInfo;
};

export const logout = () => {
  return (dispatch, getState) => {
    const user = getState().user;
    const token = (user || {}).access_token;
    dispatch(logoutRequest());

    const authConfig = config.getAuthConfig(localStorage.getItem('useSAML'));
    return http
      .post(authConfig.LOGOUT.url, {
        ...authConfig.LOGOUT.params,
        [authConfig.LOGOUT.token_key]: token,
      })
      .catch(() => true) // Logout means logout, logout cannot fail
      .then(() => localStorage.removeItem('mercuryUser'))
      .then(() => localStorage.removeItem('useSAML'))
      .then(() => localStorage.removeItem('sso_token'))
      .then(() => dispatch(disconnectWs()))
      .then(() => dispatch(logoutDone()))
      .then(() => history.push(config.BASE_ROUTE + 'login'));
  };
};
